
<template>
  <div class="main-content">
    <Container
      :title="t('route.labelHistory')"
      :hasLine="true"
    >
      <template #header>
        <SearchForm
          ref="searchFormRef"
          :formModel="searchFormModel"
          :formStruct="searchFormStruct"
          :submitButton="t('common.search')"
          :resetButton="t('common.reset')"
          @submit="submitSearch"
          @reset="resetForm"
        />
      </template>
      <template #main>
        <!--<el-button
          v-if="this.$hasPermission(['ACTION_vcLabelHistoryEdit'])"
          @click="handleCreate()"
          type="success"
        >
          {{ t('table.add') }}
        </el-button>-->
        <el-button
          v-if="selection.length > 0 && this.$hasPermission(['ACTION_vcLabelHistoryEdit'])"
          @click="handleBathDelete()"
          type="danger"
        >
          {{ t('table.bathDelete') }}
        </el-button>
        <SimpleTable
          :isLoading="listLoading"
          :tableData="tableData"
          :columnStruct="columnStruct"
          :sort="sort"
          :order="order"
          :operateColumnWidth="100"
          @handleOrder="handleOrder"
          @handleSelection="handleSelection"
        >
          <template
            v-if="this.$hasPermission(['ACTION_vcLabelHistoryEdit'])"
            #default="slotProps"
          >
            <!--<el-button
              @click="handleEdit(slotProps.row)"
              type="primary"
              size="mini"
            >
              {{ t('common.edit') }}
            </el-button>-->
            <el-button
              @click="handleDelete(slotProps.row.id)"
              type="danger"
              size="mini"
            >
              {{ t('common.delete') }}
            </el-button>
          </template>
        </SimpleTable>
        <el-pagination
          :total="total"
          v-show="total > 0"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-size="limit"
          :current-page="page"
          :page-sizes="[5, 10, 20]"
          layout="total, sizes, prev, pager, next, jumper"
          style="text-align: right;"
        />
      </template>
    </Container>
    <el-dialog
      v-if="this.$hasPermission(['ACTION_vcLabelHistoryEdit'])"
      :title="t(textMap[dialogStatus])"
      center
      v-model="dialogFormVisible"
      width="45%"
    >
      <NomalContainer>
        <CenterForm
          v-if="dialogStatus === 'create'"
          :formModel="createModel"
          :formStruct="createStruct"
          :formRules="labelHistoryRole"
          @submit="createSubmit"
          @reset="createReset"
        />
        <CenterForm
          v-if="dialogStatus === 'update'"
          :formModel="updateModel"
          :formStruct="updateStruct"
          :formRules="labelHistoryRole"
          @submit="updateNameSubmit"
          @reset="updateNameReset"
        />
      </NomalContainer>
    </el-dialog>
  </div>
</template>

<script lang="ts">
import { ElForm, ElMessage, ElMessageBox } from 'element-plus'
import { defineComponent, reactive, toRefs, onMounted, ref } from 'vue'
import Container from '@/components/form/container/Container.vue'
import SearchForm from '@/components/form/search/SearchForm.vue'
import SimpleTable from '@/components/table/simple/SimpleTable.vue'
import CenterForm from '@/components/form/common/CenterForm.vue'
import NomalContainer from '@/components/dfms-components/container/NomalContainer.vue'
import {
  LabelHistoryModel,
  LabelHistoryPageSearchModel,
  LabelHistorySearchModel,
  LabelHistoryAddModel,
  LabelHistoryUpdateModel,
  IdsModel
} from '@/model/product/LabelHistoryModel'
import {
  pageSearchLabelHistory,
  addLabelHistory,
  updateLabelHistory,
  removeLabelHistory,
  batchRemoveLabelHistory
} from '@/apis/product/labelHistory'
import { parseTime } from '@/utils'
import { createModel } from '@/utils/component'
import { selectOptionFormat } from '@/utils/options'
import { MaterialType } from '@/constant/options'
import { useI18n } from 'vue-i18n'

export default defineComponent({
  components: {
    Container,
    SearchForm,
    SimpleTable,
    CenterForm,
    NomalContainer
  },
  setup() {
    const { t } = useI18n()
    const searchFormRef = ref(ElForm)
    const materialTypeOption = selectOptionFormat(MaterialType.materialTypeOptions, t, MaterialType.i18nKey)
    const searchStruct = [
      { prop: 'userName', label: t('labelHistory.userName'), placeholder: t('labelHistory.userNameP'), component: 'el-input', type: 'text', model: null },
      { prop: 'materialName', label: t('labelHistory.materialName'), placeholder: t('labelHistory.materialNameP'), component: 'el-input', type: 'text', model: null },
      { prop: 'materialType', label: t('labelHistory.materialType'), placeholder: t('labelHistory.materialTypeP'), component: 'el-select', type: 'number', model: null, options: materialTypeOption },
      { prop: 'labelWidth', label: t('labelHistory.labelWidth'), placeholder: t('labelHistory.labelWidthP'), component: 'el-input', type: 'number', model: null },
      { prop: 'labelLength', label: t('labelHistory.labelLength'), placeholder: t('labelHistory.labelLengthP'), component: 'el-input', type: 'number', model: null }
    ]

    const createStruct = [
      { prop: 'userName', label: t('labelHistory.userName'), placeholder: t('labelHistory.userNameP'), component: 'el-input', type: 'text', model: null },
      { prop: 'materialName', label: t('labelHistory.materialName'), placeholder: t('labelHistory.materialNameP'), component: 'el-input', type: 'text', model: null },
      { prop: 'materialType', label: t('labelHistory.materialType'), placeholder: t('labelHistory.materialTypeP'), component: 'el-select', type: 'number', model: null, options: materialTypeOption },
      { prop: 'labelWidth', label: t('labelHistory.labelWidth'), placeholder: t('labelHistory.labelWidthP'), component: 'el-input', type: 'number', model: null },
      { prop: 'labelLength', label: t('labelHistory.labelLength'), placeholder: t('labelHistory.labelLengthP'), component: 'el-input', type: 'number', model: null },
      { prop: 'labelThumbnail', label: t('labelHistory.labelThumbnail'), placeholder: t('labelHistory.labelThumbnailP'), component: 'el-input', type: 'text', model: null },
      { prop: 'labelContent', label: t('labelHistory.labelContent'), placeholder: t('labelHistory.labelContentP'), component: 'el-input', type: 'text', model: null },
      { prop: 'labelName', label: t('labelHistory.labelName'), placeholder: t('labelHistory.labelNameP'), component: 'el-input', type: 'text', model: null },
      { prop: 'isFixedLength', label: t('labelHistory.isFixedLength'), placeholder: t('labelHistory.isFixedLengthP'), component: 'el-input', type: 'number', model: null }
    ]

    const updateStruct = [
      { prop: 'userName', label: t('labelHistory.userName'), placeholder: t('labelHistory.userNameP'), component: 'el-input', type: 'text', model: null },
      { prop: 'materialName', label: t('labelHistory.materialName'), placeholder: t('labelHistory.materialNameP'), component: 'el-input', type: 'text', model: null },
      { prop: 'materialType', label: t('labelHistory.materialType'), placeholder: t('labelHistory.materialTypeP'), component: 'el-select', type: 'number', model: null, options: materialTypeOption },
      { prop: 'labelWidth', label: t('labelHistory.labelWidth'), placeholder: t('labelHistory.labelWidthP'), component: 'el-input', type: 'number', model: null },
      { prop: 'labelLength', label: t('labelHistory.labelLength'), placeholder: t('labelHistory.labelLengthP'), component: 'el-input', type: 'number', model: null },
      { prop: 'labelThumbnail', label: t('labelHistory.labelThumbnail'), placeholder: t('labelHistory.labelThumbnailP'), component: 'el-input', type: 'text', model: null },
      { prop: 'labelContent', label: t('labelHistory.labelContent'), placeholder: t('labelHistory.labelContentP'), component: 'el-input', type: 'text', model: null },
      { prop: 'labelName', label: t('labelHistory.labelName'), placeholder: t('labelHistory.labelNameP'), component: 'el-input', type: 'text', model: null },
      { prop: 'isFixedLength', label: t('labelHistory.isFixedLength'), placeholder: t('labelHistory.isFixedLengthP'), component: 'el-input', type: 'number', model: null }
    ]

    const labelHistoryRole = {
      userName: [{ required: true, message: t('labelHistory.userName').concat(t('common.isRequired')), trigger: 'blur' }],
      materialName: [{ required: true, message: t('labelHistory.materialName').concat(t('common.isRequired')), trigger: 'blur' }],
      materialType: [{ required: true, message: t('labelHistory.materialType').concat(t('common.isRequired')), trigger: 'blur' }],
      labelWidth: [{ required: true, message: t('labelHistory.labelWidth').concat(t('common.isRequired')), trigger: 'blur' }],
      labelLength: [{ required: true, message: t('labelHistory.labelLength').concat(t('common.isRequired')), trigger: 'blur' }],
      labelThumbnail: [{ required: true, message: t('labelHistory.labelThumbnail').concat(t('common.isRequired')), trigger: 'blur' }],
      labelContent: [{ required: true, message: t('labelHistory.labelContent').concat(t('common.isRequired')), trigger: 'blur' }],
      labelName: [{ required: true, message: t('labelHistory.labelName').concat(t('common.isRequired')), trigger: 'blur' }],
      isFixedLength: [{ required: true, message: t('labelHistory.isFixedLength').concat(t('common.isRequired')), trigger: 'blur' }]
    }

    const tableStruct = [

      { prop: 'userName', label: t('labelHistory.userName'), sortable: 'custom' },
      { prop: 'materialName', label: t('labelHistory.materialName'), sortable: 'custom' },
      { prop: 'materialType', label: t('labelHistory.materialType'), formatter: (row: LabelHistoryModel) => { return materialTypeOption.find(mt => mt.value === row.materialType)?.label }, sortable: 'custom' },
      { prop: 'labelThumbnail', label: t('labelHistory.labelThumbnail'), sortable: 'custom', base64: 'labelThumbnail' },
      { prop: 'labelWidth', label: t('labelHistory.labelWidth'), sortable: 'custom' },
      { prop: 'labelLength', label: t('labelHistory.labelLength'), sortable: 'custom' },
      { prop: 'labelContent', label: t('labelHistory.labelContent'), sortable: 'custom' },
      // { prop: 'labelName', label: t('labelHistory.labelName'), sortable: 'custom' },
      // { prop: 'isFixedLength', label: t('labelHistory.isFixedLength'), formatter: (row: LabelHistoryModel) => { return row.isFixedLength.toString() === '1' ? t('common.yes') : t('common.no') }, sortable: 'custom' },
      { prop: 'createTime', label: t('common.createTime'), formatter: (row: LabelHistoryModel) => { return parseTime(row.createTime) }, sortable: 'custom' },
      { prop: 'updateTime', label: t('common.updateTime'), formatter: (row: LabelHistoryModel) => { return parseTime(row.updateTime) }, sortable: 'custom' }
    ]
    const dataMap = reactive({
      searchFormStruct: searchStruct,
      searchFormModel: createModel(searchStruct) as LabelHistorySearchModel,
      tableData: Array<LabelHistoryModel>(),
      columnStruct: tableStruct,
      listLoading: true,
      selection: Array<number>(),
      limit: 10,
      total: 0,
      page: 1,
      sort: 'createTime',
      order: 'desc',
      dialogStatus: 'create',
      textMap: {
        update: 'labelHistory.edit',
        create: 'labelHistory.create'
      },
      dialogFormVisible: false,
      labelHistoryRole: labelHistoryRole,
      createStruct: createStruct,
      createModel: createModel(createStruct) as LabelHistoryAddModel,
      updateStruct: updateStruct,
      updateModel: createModel(updateStruct) as LabelHistoryUpdateModel,
      handleSelection(item: any[]) {
        dataMap.selection = item
      },
      handleCurrentChange(page?: any) {
        dataMap.page = page
        dataMap.getList()
      },
      handleSizeChange(val: any) {
        dataMap.limit = val
        dataMap.getList()
      },
      handleOrder(column: any) {
        dataMap.sort = column.prop
        dataMap.order = column.order === 'descending' ? 'desc' : 'asc'
        dataMap.getList()
      },
      async getList() {
        dataMap.listLoading = true
        const params: LabelHistoryPageSearchModel = {
          userName: dataMap.searchFormModel.userName,
          materialName: dataMap.searchFormModel.materialName,
          materialType: dataMap.searchFormModel.materialType,
          labelWidth: dataMap.searchFormModel.labelWidth,
          labelLength: dataMap.searchFormModel.labelLength,
          labelThumbnail: dataMap.searchFormModel.labelThumbnail,
          labelContent: dataMap.searchFormModel.labelContent,
          labelName: dataMap.searchFormModel.labelName,
          isFixedLength: dataMap.searchFormModel.isFixedLength,
          page: dataMap.page,
          limit: dataMap.limit,
          sort: dataMap.sort,
          order: dataMap.order
        }
        const data = await pageSearchLabelHistory(params)
        dataMap.tableData = data?.data?.records ?? []
        const total = data?.data?.total ?? '0'
        dataMap.total = parseInt(total)

        // Just to simulate the time of the request
        setTimeout(() => {
          dataMap.listLoading = false
        }, 0.5 * 1000)
      },
      submitSearch() {
        dataMap.page = 1
        dataMap.getList()
      },
      resetForm() {
        console.log('reset')
      },
      async createSubmit() {
        const createData: LabelHistoryAddModel = {
          userName: dataMap.createModel.userName,
          materialName: dataMap.createModel.materialName,
          materialType: dataMap.createModel.materialType,
          labelWidth: dataMap.createModel.labelWidth,
          labelLength: dataMap.createModel.labelLength,
          labelThumbnail: dataMap.createModel.labelThumbnail,
          labelContent: dataMap.createModel.labelContent,
          labelName: dataMap.createModel.labelName,
          isFixedLength: dataMap.createModel.isFixedLength
        }
        const result = await addLabelHistory(createData)
        dataMap.dialogFormVisible = false
        dataMap.getList()
        if (result?.code === 0) {
          ElMessage({
            message: t('common.createSuccess'),
            type: 'success',
            duration: 2000
          })
        } else {
          ElMessage({
            message: result?.message,
            type: 'error',
            duration: 2000
          })
        }
      },
      async updateNameSubmit() {
        const updateData: LabelHistoryUpdateModel = {
          id: dataMap.updateModel.id,
          userName: dataMap.updateModel.userName,
          materialName: dataMap.updateModel.materialName,
          materialType: dataMap.updateModel.materialType,
          labelWidth: dataMap.updateModel.labelWidth,
          labelLength: dataMap.updateModel.labelLength,
          labelThumbnail: dataMap.updateModel.labelThumbnail,
          labelContent: dataMap.updateModel.labelContent,
          labelName: dataMap.updateModel.labelName,
          isFixedLength: dataMap.updateModel.isFixedLength
        }
        const result = await updateLabelHistory(updateData)
        dataMap.dialogFormVisible = false
        dataMap.getList()
        if (result?.code === 0) {
          ElMessage({
            message: t('common.updateSuccess'),
            type: 'success',
            duration: 2000
          })
        } else {
          ElMessage({
            message: result?.message,
            type: 'error',
            duration: 2000
          })
        }
      },
      async deleteData(id: number) {
        const result = await removeLabelHistory(id)
        dataMap.getList()
        if (result?.code === 0) {
          ElMessage({
            message: t('common.deleteSuccess'),
            type: 'success',
            duration: 2000
          })
        } else {
          ElMessage({
            message: result?.message,
            type: 'error',
            duration: 2000
          })
        }
      },
      async bathDeleteData() {
        const deleteData: IdsModel = { ids: dataMap.selection }
        const result = await batchRemoveLabelHistory(deleteData)
        dataMap.getList()
        if (result?.code === 0) {
          ElMessage({
            message: t('common.deleteSuccess'),
            type: 'success',
            duration: 2000
          })
        } else {
          ElMessage({
            message: result?.message,
            type: 'error',
            duration: 2000
          })
        }
      },
      updateNameReset() {
        console.log('update reset')
      },
      createReset() {
        console.log('create reset')
      }
    })
    const handleCreate = () => {
      dataMap.dialogStatus = 'create'
      dataMap.dialogFormVisible = true
    }
    const handleEdit = (row?: LabelHistoryModel) => {
      if (row) {
        dataMap.dialogStatus = 'update'
        dataMap.updateModel.id = row.id
        dataMap.updateModel.userName = row.userName
        dataMap.updateModel.materialName = row.materialName
        dataMap.updateModel.materialType = row.materialType
        dataMap.updateModel.labelWidth = row.labelWidth
        dataMap.updateModel.labelLength = row.labelLength
        dataMap.updateModel.labelThumbnail = row.labelThumbnail
        dataMap.updateModel.labelContent = row.labelContent
        dataMap.updateModel.labelName = row.labelName
        dataMap.updateModel.isFixedLength = row.isFixedLength
        dataMap.dialogFormVisible = true
      }
    }
    const handleDelete = (id: number) => {
      ElMessageBox.confirm(t('common.deleteTip'), t('message.tip'), {
        confirmButtonText: t('message.confirm'),
        cancelButtonText: t('message.cancel'),
        type: 'warning'
      }).then(async() => {
        await dataMap.deleteData(id)
      }).catch(() => {
        ElMessage({
          type: 'info',
          message: t('common.cancelDelete'),
          duration: 2000
        })
      })
    }
    const handleBathDelete = () => {
      ElMessageBox.confirm(t('common.deleteTip'), t('message.tip'), {
        confirmButtonText: t('message.confirm'),
        cancelButtonText: t('message.cancel'),
        type: 'warning'
      }).then(async() => {
        await dataMap.bathDeleteData()
      }).catch(() => {
        ElMessage({
          type: 'info',
          message: t('common.cancelDelete'),
          duration: 2000
        })
      })
    }
    onMounted(() => {
      dataMap.getList()
    })
    return {
      t,
      handleCreate,
      handleEdit,
      handleDelete,
      handleBathDelete,
      searchFormRef,
      ...toRefs(dataMap)
    }
  }
})
</script>
